module.exports = __webpack_public_path__ + "static/media/flask-poison.10c4674c.svg";